<ui-data-table
  [title]="title()"
  [columns]="columns()"
  [rows]="displayRows()"
  [total]="total()"
  [loading]="loading()"
  [showNewButton]="true"
  [showStatusFilter]="false"
  [showActionsColumn]="true"
  [actionItems]="actionItems"
  (sortChange)="onSort($event)"
  (columnFiltersChange)="onFilter($event)"
  (actionClick)="onActionClick($event)"
  (newClick)="onNew()"
  (exportExcel)="onExportExcel()"
/>

<ui-drawer
  [(open)]="open"
  [title]="drawerTitle()"
  cancelLabel="Cerrar"
  saveLabel="Guardar"
  panelWidth="590px"
  [showSaveButton]="!fieldsLocked()"
  [closeOnSave]="closeOnSave()"
  (saved)="onSave()"
>
  <div class="ui-entity-documents__form">
    <ui-form-section title="Generales">
      <div class="ui-entity-documents__fields">
        <ui-input
          class="ui-entity-documents__field-nombre"
          label="Nombre"
          [required]="!fieldsLocked()"
          [showOptionalHint]="!fieldsLocked()"
          [disabled]="fieldsLocked()"
          [block]="true"
          [(value)]="docNombre"
        />
        @if (!fieldsLocked() || savedFiles().length) {
          <div class="ui-entity-documents__field-upload">
            <ui-file-upload
              label="Documentos"
              [required]="mode() === 'new'"
              [showOptionalHint]="!fieldsLocked()"
              [multiple]="true"
              [allowAnyFileType]="true"
              [block]="true"
              [allowAdd]="!fieldsLocked()"
              [removable]="!fieldsLocked()"
              [storedRemovable]="canRemoveStoredFiles()"
              [storedFiles]="savedFiles()"
              (storedRemove)="onStoredFileRemove($event)"
              [(value)]="docArchivos"
            />
          </div>
        }
      </div>
    </ui-form-section>

    <ui-form-section title="Notas">
      <ui-textarea
        label="Notas"
        [block]="true"
        [disabled]="fieldsLocked()"
        [showOptionalHint]="!fieldsLocked()"
        [(value)]="docNotas"
      />
    </ui-form-section>
  </div>
</ui-drawer>
